import { AUTHORITIES as APP_AUTHORITIES } from 'domain/fuse/auth/constants';
import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/DASHBOARD`;

export const REDUCER_NAME = 'operationsDashboard';

export const AUTHORITIES = [
  APP_AUTHORITIES.FLEET_ADMIN,
  APP_AUTHORITIES.OPERATOR,
  APP_AUTHORITIES.ACCOUNT_ADMIN,
];

export const ROUTES = {
  ROOT: '/ops-dashboard',
};
